import React from "react";
import "./PlayStoreButton.css"; // Ensure you create this CSS file

const PlayStoreButton = () => {
  return (
    <a
      href={process.env.REACT_APP_PLAYSTORE_LINK} // Replace with your actual app URL
      className="playstore-button"
      target="_blank"

      rel="noopener noreferrer"
    >
      <img
        src="assets/images/google-playstore.png"
        alt="Get it on Google Play"
        className="playstore-img"
      />
      <div style={{ display: "flex",flexDirection:"column" }}>
        <p style={{color:"white"}}>GET IN ON</p>
        <p style={{color:"white"}}>Google Play Store</p>
      </div>
    </a>
  );
};

export default PlayStoreButton;
